import React from 'react';
import { useSelector } from 'react-redux';

// Types

// Hooks
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

// Components
import IntegrationsList from 'Dashboard/components/IntegrationsList/IntegrationsList';
import HibobSettings from './HibobSettings/HibobSettings';
import MetaWorkplaceSetup from './MetaWorkplaceSetup/MetaWorkplaceSetup';

// Styles
import './Enterprise.scss';

const Enterprise = () => {
  const { isOrgAdmin } = useCurrentUser();
  const hibobDataSource = useSelector(state => state.data_sources.find(({ slug }) => slug === 'hibob'));
  const hiBobIsConnected = !!hibobDataSource?.connected;

  if (!isOrgAdmin) return null;

  return (
    <div>
      {hiBobIsConnected && <HibobSettings />}
      {!hiBobIsConnected && <IntegrationsList integrations={[hibobDataSource]} />}
      <MetaWorkplaceSetup />
    </div>
  );
};

export default Enterprise;
